module.exports = __webpack_public_path__ + "img/desktop/Background-freespins/fsbackground@3x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Background-freespins/fsbackground@3x.jpg
// module id = 174
// module chunks = 0